import { hashFn } from './hash-fn';
import { queryRetryDelay, shouldRetryQuery } from './query-retry';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient, defaultShouldDehydrateQuery } from '@tanstack/react-query';
import localForage from 'localforage';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: hashFn,
      gcTime: 10 * 60 * 1e3,
      staleTime: 30 * 1e3, // 30 seconds - keep cached data fresh longer to avoid flicker on refresh
      retry: shouldRetryQuery,
      retryDelay: queryRetryDelay,
      retryOnMount: true,
      refetchInterval: false, // 1 * 60 * 1e3,
      refetchOnReconnect: true,
      refetchOnMount: true,
      // Refresh stale data when the user returns to the tab; staleTime 30s
      // gates it so rapid tab switches stay silent
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: false,
    },
    mutations: {
      gcTime: 10 * 60 * 1e3,
    },
  },
});

export const storage = localForage.createInstance({ name: 'dpin-public-cache-v1' });

export const persister = createAsyncStoragePersister({ storage });

// Unknown and account-dependent queries stay in memory only.
export const persistOptions = {
  persister,
  buster: 'dpin-public-cache-v1',
  dehydrateOptions: {
    shouldDehydrateQuery: (query: Parameters<typeof defaultShouldDehydrateQuery>[0]) =>
      defaultShouldDehydrateQuery(query) &&
      ['BaseTokens', 'MarketTags'].some(type => query.queryKey[0] === type || query.queryKey[1] === type),
    shouldDehydrateMutation: () => false,
  },
};
